module.exports = __webpack_public_path__ + "img/Monte_Kope_84.3de9168a.jpg";